const API_URLS = {
  AUTHENTICATE: 'account/authenticate',
};

export default API_URLS;
